import { NgModule } from '@angular/core';
import { RouterModule, Routes, InitialNavigation } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LayoutContentComponent } from './modules/layout/layout-content/layout-content.component';
import { environment } from 'src/environments/environment';

const isIframe = window !== window.parent && !window.opener;
const guards: any[] = environment.isCommercialization ? [] : [MsalGuard];

export const routers: Routes = [
    {
        path: '',
        loadChildren: () => import(`./portal/portal.module`).then(m => m.PortalModule),
    },
    {
        path: 'dashboard',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: guards
    },
    {
        path: 'users',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
        canActivate: guards
    },
    {
        path: 'adduser',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/adduser/adduser.module').then(m => m.AddUserModule),
        canActivate: guards
    },
    {
        path: 'edituser/:id',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/edituser/edituser.module').then(m => m.EditUserModule),
        canActivate: guards
    },
    {
        path: 'roles',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/roles/roles.module').then(m => m.RolesModule),
        canActivate: guards
    },
    {
        path: 'addrole',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/addrole/addrole.module').then(m => m.AddRoleModule),
        canActivate: guards
    },
    {
        path: 'editrole/:id',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/editrole/editrole.module').then(m => m.EditRoleModule),
        canActivate: guards
    },
    {
        path: 'inspectiondate',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/inspectiondate/inspectiondate.module').then(m => m.InspectionDateModule),
        canActivate: guards
    },
    {
        path: 'dashboardimage',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/dashboardimage/dashboardimage.module').then(m => m.DashboardImageModule),
        canActivate: guards
    },
    {
        path: 'inspectionrequest',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/inspectionrequest/inspectionrequest.module').then(m => m.InspectionRequestModule),
        canActivate: guards
    },
    {
        path: 'editinspectionrequest/:id',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/editinspectionrequest/editinspectionrequest.module').then(m => m.EditInspectionRequestModule),
        canActivate: guards
    },
    {
        path: 'pendingrequest',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/pendingrequest/pendingrequest.module').then(m => m.PendingRequestModule),
        canActivate: guards
    },
    {
        path: 'metoceanpointsrequest',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/metoceanpointsrequest/metoceanpointsrequest.module').then(m => m.MetoceanPointsRequestModule),
        canActivate: guards
    },
    {
        path: 'vectorizeddatarequest',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/vectorizeddatarequest/vectorizeddatarequest.module').then(m => m.VectorizedDataRequestModule),
        canActivate: guards
    },
    {
        path: 'addinspectiondate',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/addinspectiondate/addinspectiondate.module').then(m => m.AddInspectionDateModule),
        canActivate: guards
    },
    {
        path: 'adddashboardimage',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/adddashboardimage/adddashboardimage.module').then(m => m.AddDashboardImageModule),
        canActivate: guards
    },
    {
        path: 'editinspectiondate/:id',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/editinspectiondate/editinspectiondate.module').then(m => m.EditInspectionDateModule),
        canActivate: guards
    },
    {
        path: 'pipelinemanagement',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/pipelinemanagement/pipelinemanagement.module').then(m => m.PipelineManagementModule),
        canActivate: guards
    },
    {
        path: 'addpipeline',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/addpipeline/addpipeline.module').then(m => m.AddPipelineModule),
        canActivate: guards
    },
    {
        path: 'editpipeline/:id',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/editpipeline/editpipeline.module').then(m => m.EditPipelineModule),
        canActivate: guards
    },
    {
        path: 'uwi',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/uwi/uwi.module').then(m => m.UWIModule),
        canActivate: guards
    },
    {
        path: 'addinspection',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/addinspection/addinspection.module').then(m => m.AddInspectionModule),
        canActivate: guards
    },
    {
        path: 'plotspandistribution',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/plotspandistribution/plotspandistribution.module').then(m => m.PlotSpanDistributionModule),
        canActivate: guards
    },
    {
        path: 'metoceanpoints',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/metoceanpoints/metoceanpoints.module').then(m => m.MetoceanPointsModule),
        canActivate: guards
    },
    {
        path: 'addmetoceanpoints',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/addmetoceanpoints/addmetoceanpoints.module').then(m => m.AddMetoceanPointsModule),
        canActivate: guards
    },
    {
        path: 'vectorizeddata',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/vectorizeddata/vectorizeddata.module').then(m => m.VectorizedDataModule),
        canActivate: guards
    },
    {
        path: 'gis',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/gis/gis.module').then(m => m.GISModule),
        canActivate: guards
    },
    {
        path: 'span',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/span/span.module').then(m => m.SpanModule),
        canActivate: guards
    },
    {
        path: 'prediction',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/prediction/prediction.module').then(m => m.PredictionModule),
        canActivate: guards
    },
    {
        path: 'addprediction',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/addprediction/addprediction.module').then(m => m.AddPredictionModule),
        canActivate: guards
    },
    {
        path: 'viewprediction/:id',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/viewprediction/viewprediction.module').then(m => m.ViewPredictionModule),
        canActivate: guards
    },
    {
        path: 'viewticket',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/viewticket/viewticket.module').then(m => m.ViewTicketModule),
        canActivate: guards
    },
    {
        path: 'support',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/support/support.module').then(m => m.SupportModule),
        canActivate: guards
    },
    {
        path: 'userguide',
        component: LayoutContentComponent,
        loadChildren: () => import('./modules/userguide/userguide.module').then(m => m.UserGuideModule),
        canActivate: guards
    },
    {
        path: 'redirection',
        loadChildren: () => import('./modules/redirection/redirection.module').then(m => m.RedirectionModule)
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routers, {
          initialNavigation: 'enabled',
        } as unknown as { initialNavigation: InitialNavigation }), // Use InitialNavigation here
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
